import defprotocol from '../defprotocol'
import Function from '../types/Function'

const Counted = defprotocol({
  count: Function
})

export default Counted
